import {
  GenericField,
  InputProps,
} from "@/lib/Components/Form/Fields/GenericField";
import { useField } from "formik";
import { SwitchControl } from "@/lib/Components/Form/Inputs/SwitchControl";

type SwitchInputProps = InputProps & {
  onChange?: (value: boolean) => void;
};
export function SwitchInput({ onChange, ...props }: SwitchInputProps) {
  const [field, , helpers] = useField(props.name);
  const { value } = field;
  const enabled = !!value;

  return (
    <GenericField {...props} viewNode={<span>{value ? "YES" : "NO"}</span>}>
      <SwitchControl
        checked={enabled}
        onChange={(val) => {
          helpers.setValue(val);
          onChange?.(val);
        }}
      />
    </GenericField>
  );
}
